import routes from './routes'
import store from './store'

export default {
    name: 'm-redactor',
    store: store,
    routes: routes
}